import { getBaseUrl } from '@utilities/helpers/core.helpers'

export const stripWpUrl = (url: string) => {
  if (!url) return ''
  if (!url.includes('wp.')) return url
  const baseUrl = getBaseUrl()
  return url.replace(baseUrl, '')
}
